module.exports = __webpack_public_path__ + "img/chantier.8e57b26b.svg";